import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TranslationService {
    private currentLang: string = 'en'; // Default language is English
    private translations: any = {}; // To store translations
    private currentTranslation = new BehaviorSubject<any>({}); // Current translation based on language

    constructor(private http: HttpClient) {
        // Load translations from the json file
        this.loadTranslations();
    }

    // Load translations from the JSON file
    loadTranslations() {
        this.http
            .get<any>('/translation/en_zh.json')
            .subscribe((translations) => {
                console.log('Translations loaded:', translations);
                this.translations = translations;
                this.updateTranslation(); // Set the default language translation
            });
    }

    // Switch the current language
    switchLanguage(lang: string) {
        this.currentLang = lang;
        this.updateTranslation();
    }

    // Update the current language translation
    private updateTranslation() {
        const translation = this.translations[this.currentLang] || {};
        this.currentTranslation.next(translation);
    }

    // Get localized text by key
    getLocalizedText(key: string): string {
        const translation = this.currentTranslation.getValue();

        // Split the key by '.' to handle nested keys
        const keys = key.split('.');

        let result = translation;

        // Traverse through the nested keys
        for (let part of keys) {
            result = result[part]; // Access the nested value
            if (!result) {
                return key; // If the value is not found, return the original key
            }
        }

        return result; // Return the final value if found
    }
}
